import React, { Component } from 'react'
import {
    Row,
    Col,
    Input,
    Button,
    PageHeader,
    Table,
    message,
} from 'antd';
import { DoubleRightOutlined } from '@ant-design/icons';
import axios from 'axios'
import qs from 'qs'
import Addmoudel from '../Addmoudel'
import Editmoudel from '../Editmoudel'
import Deletepopup from '../Deletepopup'

export default class Moudel extends Component {

    constructor(props) {
        super(props);

        // 转化日期格式的函数
        function dateFormat(fmt, date) {
            let ret;
            const opt = {
                "Y+": date.getFullYear().toString(),        // 年
                "m+": (date.getMonth() + 1).toString(),     // 月
                "d+": date.getDate().toString(),            // 日
                "H+": date.getHours().toString(),           // 时
                "M+": date.getMinutes().toString(),         // 分
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                };
            };
            return fmt;
        }

        this.columns = [
            {
                title: '模块名称',
                dataIndex: 'name',
                render: (text, record, index) =>
                    this.state.data.length >= 1 ? (
                        <Editmoudel name={record.name} id={record.id} address='模块' editData={this.editData} />
                    ) : null,
            },
            {
                title: '更新日期',
                dataIndex: 'date',
                render: (_, record) =>
                    this.state.data.length >= 1 ? (
                        dateFormat('YYYY-mm-dd HH:MM', new Date(record.createTime))
                    ) : null,
            },
            {
                title: '操作',
                dataIndex: 'operation',
                width: '100px',
                render: (_, record) =>
                    this.state.data.length >= 1 ? (
                        <Deletepopup address='模块' delData={() => this.handleDelete(record.id)}></Deletepopup>
                    ) : null,
            },
        ];
        this.state = {
            pagination: {
                current: 1,
                pageSize: 10,
                onChange: (page) => {
                    this.setState({
                        pagination: { ...this.state.pagination, current: page }
                    }, () => {
                        this.sendRequset()
                    })
                }
            },
            loading: false,
            showForm: false,
            searchValue: '',
            selectedRowKeys: [],
            data: []
        };
    }

    componentDidMount() {
        this.sendRequset()
    }

    // 请求数据
    sendRequset = () => {
        const listRequest = axios.create({
            baseURL: 'https://office.yunbiaokj.com:40005',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        });
        listRequest({
            transformRequest: [function (data) {
                data = qs.stringify(data)
                return data
            }],
            method: 'POST',
            url: '/mxmService/s_setting/list',
            data: {
                limit: 10,
                page: this.state.pagination.current,
                type: 'APPLICATION_MODULE',
                name: ''
            },
        }).then((response) => {
            this.setState({
                data: response.data.page.list,
                pagination: { ...this.state.pagination, total: response.data.page.totalCount }
            })
        })
    }

    // 展开搜索的显示和隐藏
    handleClick = () => {
        this.setState({ showForm: !this.state.showForm })
    }

    // 搜索按钮的回调函数
    onSearch = () => {
        const listRequest = axios.create({
            baseURL: 'https://office.yunbiaokj.com:40005',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        });
        listRequest({
            transformRequest: [function (data) {
                data = qs.stringify(data)
                return data
            }],
            method: 'POST',
            url: '/mxmService/s_setting/list',
            data: {
                limit: 10,
                page: 1,
                type: 'APPLICATION_MODULE',
                name: this.state.searchValue
            },
        }).then((response) => {
            this.setState({
                data: response.data.page.list
            })
        })
    }

    // 重置按钮
    resetSearch = () => {
        const listRequest = axios.create({
            baseURL: 'https://office.yunbiaokj.com:40005',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        });
        listRequest({
            transformRequest: [function (data) {
                data = qs.stringify(data)
                return data
            }],
            method: 'POST',
            url: '/mxmService/s_setting/list',
            data: {
                limit: 20,
                page: 1,
                type: 'APPLICATION_MODULE',
                name: ''
            },
        }).then((response) => {
            this.setState({
                data: response.data.page.list,
                searchValue: ''
            })
        })

    }

    // 复选框
    selectRow = (record) => {
        const selectedRowKeys = [...this.state.selectedRowKeys];
        if (selectedRowKeys.indexOf(record.id) >= 0) {
            selectedRowKeys.splice(selectedRowKeys.indexOf(record.id), 1);
        } else {
            selectedRowKeys.push(record.id);
        }
        this.setState({ selectedRowKeys });
        return record
    }
    onSelectedRowKeysChange = (selectedRowKeys) => {
        this.setState({ selectedRowKeys });
    }

    // 单条数据删除
    handleDelete = (id) => {
        const deleteRequest = axios.create({
            baseURL: 'https://office.yunbiaokj.com:40005',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        })
        deleteRequest({
            transformRequest: [function (data) {
                data = qs.stringify(data)
                return data
            }],
            method: 'POST',
            url: '/mxmService/s_setting/delete',
            data: {
                'type': 'APPLICATION_MODULE',
                'ids': id,
            }
        }).then(() => {
            this.sendRequset()
        }).catch((err) => {
            console.log(err);
        })
    };

    // 用户为勾选数据 点击删除时的提示
    error = () => {
        message.error({
            content: '请选择需要删除的数据',
            style: {
                marginTop: '28vh',
            },
        })
    }

    // 删除多条数据
    handleManyDelete = (id) => {
        if (id.length === 0) {
            this.error()
        } else {
            const ids = id.join(',')
            const deleteRequest = axios.create({
                baseURL: 'https://office.yunbiaokj.com:40005',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
            })
            deleteRequest({
                transformRequest: [function (data) {
                    data = qs.stringify(data)
                    return data
                }],
                method: 'POST',
                url: '/mxmService/s_setting/delete',
                data: {
                    'type': 'APPLICATION_MODULE',
                    'ids': ids
                }
            }).then(() => {
                this.sendRequset()
            }).catch((err) => {
                console.log(err);
            })
        }
    };

    // 添加数据
    addData = (value) => {
        const instance = axios.create({
            baseURL: 'https://office.yunbiaokj.com:40005',
            headers: { 'Content-Type': 'application/json' }
        });
        const param = {
            'id': "",
            'name': value,
            'type': "APPLICATION_MODULE"
        }
        instance({
            transformRequest: [function (data) {
                data = JSON.stringify(data)
                return data
            }],
            method: 'POST',
            url: '/mxmService/s_setting/save',
            data: param,
        }).then(() => {
            this.sendRequset()
        }).catch((err) => {
            console.log(err);
        })
    }

    // 编辑数据
    editData = (value, id) => {
        const listRequest = axios.create({
            baseURL: 'https://office.yunbiaokj.com:40005',
            headers: { 'Content-Type': 'application/json' }
        });
        listRequest({
            transformRequest: [function (data) {
                data = JSON.stringify(data)
                return data
            }],
            method: 'POST',
            url: '/mxmService/s_setting/update',
            data: {
                id: id,
                name: value,
                type: 'APPLICATION_MODULE',
            },
        }).then(() => {
            this.sendRequset()
        })
    }

    // 动态绑定input输入框的是数据
    handleChange = (event) => {
        this.setState({
            searchValue: event.target.value
        })
    }

    render() {
        const { showForm, data, pagination } = this.state;
        // 获取复选框部分代码
        const { selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectedRowKeysChange,
        };
        const columns = this.columns

        return (
            <div className="app-body" >
                <PageHeader
                    ghost={false}
                    className="gray-header"
                    title={
                        <div>
                            <Addmoudel btnName='模块' addData={this.addData} />&emsp;
                            <Deletepopup delType='btn' address='模块' delData={() => this.handleManyDelete(selectedRowKeys)} />
                        </div>
                    }
                    extra={[
                        <Button className="pos-bottom"
                            key="1"
                            onClick={this.handleClick}
                            icon={<DoubleRightOutlined rotate={showForm ? 270 : 90} />}>展开查询</Button>,
                    ]}
                />
                <div style={{ backgroundColor: '#F5F5F5', display: showForm ? 'block' : 'none', borderBottom: '1px solid #dddddd' }} >
                    <Row gutter={16} align={'middle'} style={{ padding: '21px 15px' }}>
                        <Col >
                            <span>模块名称：</span>
                        </Col>
                        <Col span={8} >
                            <Input placeholder="模块名称" onChange={this.handleChange} value={this.state.searchValue} />
                            {/* ref={c => this.myRef = c} */}
                        </Col>
                        <Col span={6}>
                            <Button type="danger" onClick={this.onSearch}>
                                搜索
                            </Button>
                            &emsp;
                            <Button onClick={this.resetSearch} style={{ margin: '0 8px' }}>
                                重置
                            </Button>
                        </Col>
                    </Row>
                </div>

                {/* 带复选框的表格组件 */}
                <div>
                    <Table
                        rowKey='id'
                        rowSelection={rowSelection}
                        pagination={pagination}
                        columns={columns}
                        dataSource={data}
                    />
                </div >
            </div >
        )
    }
}